import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Demande from "@/pages/Demande";
import Confidentialite from "@/pages/Confidentialite";
import Admin from "@/pages/Admin";
import Projet from "@/pages/Projet";
import CreationSiteInternet from "@/pages/CreationSiteInternet";
import Conseils from "@/pages/Conseils";
import Article from "@/pages/Article";
import CookieBanner from "@/components/site/CookieBanner";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView();
      }, 350);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function VisitTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (localStorage.getItem("adw-cookies") === "accepted" && !pathname.startsWith("/admin")) {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/visits`, { page: pathname }).catch(() => {});
    }
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <VisitTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/demande" element={<Demande />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/realisations/:slug" element={<Projet />} />
          <Route path="/creation-site-internet" element={<CreationSiteInternet />} />
          <Route path="/conseils" element={<Conseils />} />
          <Route path="/conseils/:slug" element={<Article />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <CookieBanner />
        <Toaster position="bottom-right" theme="dark" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
